import { a6 as attr, a7 as stringify, a5 as store_get, a8 as unsubscribe_stores } from "./index.js";
import { w as writable } from "./index3.js";
const loading = writable(true);
function Loading($$payload) {
  var $$store_subs;
  $$payload.out += `<div${attr("class", `w-full h-full fixed top-0 left-0 bg-gray-950 flex items-center justify-center transition-all duration-300 ${stringify(store_get($$store_subs ??= {}, "$loading", loading) ? "opacity-100" : "opacity-0 pointer-events-none")} z-50 svelte-6jyoaj`)}><span class="loader svelte-6jyoaj"></span></div>`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
}
export {
  Loading as L
};
